<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div>
      <div id="track">
        <div class="d-flex justify-content-between">
          <div>
            <a href="/ExhibitorServiceTW/">Exhibition List</a><span>/</span
            ><em name="Exhibition"></em><span>/</span
            ><span class="px-0">Other Events</span><span>/</span
            ><a href="javascript:history.back()">{{ EventName }}</a
            ><span>/</span>Edit Promotional Information
          </div>
          <div>
            <span class="bold">Account :</span>
            <span> {{ UserId }}</span>
          </div>
        </div>
      </div>
      <!-- track end -->
      <!-- article -->
      <article>
        <div class="contentBox">
          <div class="container">
            <h1>Edit Promotional Information</h1>
            <p class="my-3">&nbsp;</p>
            <p class="alert">
              <i class="fas fa-exclamation-circle"></i>
              Do not upload content that is irrelevant to this exhibition. The
              organizer reserves the right to delete inappropriate content.
            </p>
            <p class="my-3">&nbsp;</p>

            <form id="form" @submit.prevent="EditPromotionPro">
              <input type="hidden" name="RegNo" />

              <p class="formTitle">Product Name</p>
              <p>
                {{ ProductName }}
              </p>

              <p class="my-3">&nbsp;</p>

              <p class="formTitle">Category <span class="red">*</span></p>
              <div class="form-row">
                <div class="form-group col-md-4">
                  <select
                    class="form-control text-dark"
                    v-model="PromotionProDetail.mCatID"
                    required
                  >
                    <option value="">-- Select --</option>
                    <option v-for="item in EventCatList" :value="item.mCatID">
                      {{ item.emCatName }}
                    </option>
                  </select>
                </div>
              </div>
              <p class="clear"></p>
              <p class="my-3">&nbsp;</p>

              <div v-if="inputDescHidden == 0">
                <div v-if="einputDescName">
                  <p class="formTitle">
                    {{ einputDescName }}
                    <span class="red" v-if="inputDescRequired == 0">*</span>
                  </p>

                  <div class="langTip">
                    <input
                      type="text"
                      name="Desc"
                      class="maxText textStyle"
                      :required="inputDescRequired == 0"
                      maxlength="50"
                      v-model="PromotionProDetail.ereg_Desc"
                    />
                    <span>En </span>
                  </div>
                  <div class="blueBG mt-1" v-if="einputDescNotes">
                    {{ einputDescNotes }}
                  </div>
                </div>

                <div v-if="inputDescName">
                  <div v-if="LocalExh">
                    <div class="langTip mt-2">
                      <input
                        type="text"
                        name="Desc"
                        class="maxText textStyle"
                        :required="inputDescRequired == 0"
                        maxlength="20"
                        v-model="PromotionProDetail.reg_Desc"
                      />
                      <span>Cn </span>
                    </div>
                    <div class="blueBG mt-1" v-if="inputDescNotes">
                      {{ inputDescNotes }}
                    </div>
                  </div>
                </div>

                <p class="my-3">&nbsp;</p>
              </div>

              <div class="mt-3" v-if="inputDescHidden2 == 0">
                <div v-if="einputDescName2">
                  <p class="formTitle">
                    {{ einputDescName2 }}
                    <span class="red" v-if="inputDescRequired2 == 0">*</span>
                  </p>

                  <div class="langTip">
                    <input
                      type="text"
                      name="Desc2"
                      class="maxText textStyle"
                      :required="inputDescRequired2 == 0"
                      maxlength="50"
                      v-model="PromotionProDetail.ereg_Desc2"
                    />
                    <span>En </span>
                  </div>
                  <div class="blueBG mt-1" v-if="einputDescNotes2">
                    {{ einputDescNotes2 }}
                  </div>
                </div>
                <div v-if="inputDescName2">
                  <div v-if="LocalExh">
                    <div class="langTip mt-2">
                      <input
                        type="text"
                        name="Desc2"
                        class="maxText textStyle"
                        :required="inputDescRequired2 == 0"
                        maxlength="20"
                        v-model="PromotionProDetail.reg_Desc2"
                      />
                      <span>Cn </span>
                    </div>
                    <div class="blueBG mt-1" v-if="inputDescNotes2">
                      {{ inputDescNotes2 }}
                    </div>
                  </div>
                </div>
                <p class="my-3">&nbsp;</p>
              </div>

              <span v-if="inputOnlineDateHidden == 0">
                <p class="formTitle mt-3">
                  Launch Date
                  <span class="red" v-if="inputOnlineDateRequired == 0">*</span>
                </p>
                <div>
                  <input
                    type="text"
                    name="LaunchDate"
                    class="maxText textStyle"
                    :required="inputOnlineDateRequired == 0"
                    maxlength="20"
                    v-model="PromotionProDetail.reg_LaunchDate"
                  />
                </div>
                <p class="my-3">&nbsp;</p>
              </span>

              <span v-if="inputPriceHidden == 0">
                <p class="formTitle">
                  Regular Price (NT$)
                  <span class="red" v-if="inputPriceRequired == 0">*</span>
                </p>
                <div>
                  <input
                    type="text"
                    name="Price"
                    class="maxText textStyle"
                    :required="inputPriceRequired == 0"
                    maxlength="20"
                    v-model="PromotionProDetail.reg_Price"
                  />
                </div>
                <p class="my-3">&nbsp;</p>
              </span>

              <span v-if="inputDiscountPriceHidden == 0">
                <p class="formTitle">
                  Exhibition Offer (NT$)
                  <span class="red" v-if="inputDiscountPriceRequired == 0"
                    >*</span
                  >
                </p>
                <div>
                  <input
                    type="text"
                    name="Discount"
                    class="maxText textStyle"
                    :required="inputDiscountPriceRe == 0"
                    maxlength="20"
                    v-model="PromotionProDetail.reg_DiscountPrice"
                  />
                </div>
                <p class="my-3">&nbsp;</p>
              </span>
              <div class="d-flex justify-content-center">
                <input type="submit" value="Send" class="btnStyle mr-4" />
                <div class="btnStyle btnGray" @click.prevent="toPromotionList">
                  Back
                </div>
              </div>
            </form>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  metaInfo() {
    return {
      title:
        "Edit Promotional Information - Chan Chao Exhibitor Online Service System",
    };
  },

  data() {
    return {
      LocalExh: true,
      UserId: "",
      RegNo: "",
      CSRF_Token: "",
      lang: "tw",
      EventDetail: {},
      MarketingRegisterList: [],
      ProductID: "",
      PromotionProDetail: {},
      reg_Desc: "",
      reg_Desc2: "",
      ereg_Desc: "",
      ereg_Desc2: "",
      reg_LaunchDate: "",
      reg_Price: "",
      reg_DiscountPrice: "",
      EventDetail: {},
      EventCatList: [],
      mCatID: "",
      eventId: "",
      RegId: "",
      ProductName: "",
      inputDescHidden: "",
      inputOnlineDateHidden: "",
      inputPriceHidden: "",
      inputDiscountPriceHidden: "",
      inputDescName: "",
      EventName: "",

      inputDescName2: "",
      einputDescName: "",
      einputDescName2: "",
      inputDescNotes: "",
      inputDescNotes2: "",
      einputDescNotes: "",
      einputDescNotes2: "",
      inputDescRequired: "",
      inputDescRequired2: "",
      inputOnlineDateRequired: "",
      inputPriceRequired: "",
      inputDiscountPriceRequired: "",
      inputDescHidden2: "",
    };
  },

  watch: {},

  methods: {
    EditPromotionPro() {
      const vm = this;
      const url = `/apiExhibitors/MarketingEventRegisterUpdate/${vm.RegNo}/${vm.RegId}`;

      const info = {
        proNo: vm.PromotionProDetail.proNo,
        mCatID: vm.PromotionProDetail.mCatID,
        reg_Desc: vm.PromotionProDetail.reg_Desc,
        reg_Desc2: vm.PromotionProDetail.reg_Desc2,
        ereg_Desc: vm.PromotionProDetail.ereg_Desc,
        ereg_Desc2: vm.PromotionProDetail.ereg_Desc2,

        reg_LaunchDate: vm.PromotionProDetail.reg_LaunchDate,
        reg_Price: vm.PromotionProDetail.reg_Price,
        reg_DiscountPrice: vm.PromotionProDetail.reg_DiscountPrice,
        CSRF: vm.CSRF_Token,
      };

      // console.log(info)

      axios.post(url, info).then(function (response) {
        if (response.data.Code == 200) {
          alert("You have successfully uploaded!");
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
        } else if (response.data.Code == 500) {
          alert("The system is busy. Please try again later.");
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
        } else if (response.data.Code == 252) {
          // console.log('CSRF驗證失敗')
        } else if (response.data.Code == 253) {
          alert("Registration number is incorrect or does not exist.");
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
        } else if (response.data.Code == 254) {
          alert(
            "Exhibitor registration number is incorrect or does not exist."
          );
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
        }
      });
    },

    toPromotionList() {
      const vm = this;
      document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
    },
  },

  computed: {},

  created() {
    const vm = this;

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1].split("&")[0];
    vm.eventId = currentUrl.split("eventId=")[1].split("&")[0];
    vm.RegId = currentUrl.split("regId=")[1];

    let url2 = `/apiExhibitors/MarketingEventRegister/${vm.RegNo}/${vm.RegId}`;
    axios.get(url2).then(function (response) {
      // console.log(response.data)
      vm.PromotionProDetail = response.data.Data[0];
      // console.log(vm.PromotionProDetail)
      let GetProNo = vm.PromotionProDetail.proNo;

      let url = `/apiExhibitors/Product/${vm.RegNo}/${GetProNo}`;
      axios.get(url).then(function (response) {
        // console.log(response.data.Data)
        vm.ProductName = response.data.Data.ProName;
      });
    });

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`
      )
      .then((response) => {
        let ExpoLocation = response.data.Data.ExpoLocation;

        if (ExpoLocation === "T" || ExpoLocation === null) {
          vm.LocalExh = true;
        } else {
          vm.LocalExh = false;
        }
      });

    //取得總資料
    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/MarketingEvent?eventId=${vm.eventId}`
      )
      .then((response) => {
        // console.log(response.data.Data)

        vm.EventDetail = response.data.Data;
        vm.EventCatList = response.data.Data.category;

        // 欄位顯示判定

        vm.inputDescHidden = response.data.Data.inputDescHidden;
        vm.inputDescHidden2 = response.data.Data.inputDescHidden2;

        vm.inputOnlineDateHidden = response.data.Data.inputOnlineDateHidden;
        vm.inputPriceHidden = response.data.Data.inputPriceHidden;
        vm.inputDiscountPriceHidden =
          response.data.Data.inputDiscountPriceHidden;

        vm.inputDescName = response.data.Data.inputDescName;
        vm.inputDescName2 = response.data.Data.inputDescName2;
        vm.einputDescName = response.data.Data.einputDescName;
        vm.einputDescName2 = response.data.Data.einputDescName2;
        vm.inputDescNotes = response.data.Data.inputDescNotes;
        vm.inputDescNotes2 = response.data.Data.inputDescNotes2;

        vm.einputDescNotes = response.data.Data.einputDescNotes;
        vm.einputDescNotes2 = response.data.Data.einputDescNotes2;

        vm.EventName = response.data.Data.eEventName;

        //必填

        vm.inputDescRequired = response.data.Data.inputDescRequired;
        vm.inputDescRequired2 = response.data.Data.inputDescRequired2;
        vm.inputOnlineDateRequired = response.data.Data.inputOnlineDateRequired;
        vm.inputPriceRequired = response.data.Data.inputPriceRequired;
        vm.inputDiscountPriceRequired =
          response.data.Data.inputDiscountPriceRequired;

        if (vm.inputDescRequired == 0) {
          $(".inputDescRe")[0].setAttribute("required", "true");
          $(".inputDescReCn")[0].setAttribute("required", "true");
        }
        if (vm.inputDescRequired2 == 0) {
          $(".inputDescRe2")[0].setAttribute("required", "true");
          $(".inputDescRe2Cn")[0].setAttribute("required", "true");
        }
        if (vm.inputOnlineDateRequired == 0) {
          $(".inputOnlineDateRe")[0].setAttribute("required", "true");
        }
        if (vm.inputPriceRequired == 0) {
          $(".inputPriceRe")[0].setAttribute("required", "true");
        }
        if (vm.inputDiscountPriceRequired == 0) {
          $(".inputDiscountPriceRe")[0].setAttribute("required", "true");
        }

        // 開啟時間判定
        let OpenRegiterDate = response.data.Data.backEndStartDate;
        let CloseRegiterDate = response.data.Data.backEndEndDate;
        let Nowdate = Date.parse(new Date()).valueOf();

        // console.log(OpenRegiterDate)
        // console.log(CloseRegiterDate)
        // console.log(Nowdate)

        if (Nowdate < OpenRegiterDate) {
          alert("The activity has not yet started.");
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
        } else if (Nowdate > CloseRegiterDate) {
          alert("The activity has not yet started.");
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
        }
      });
  },
};
</script>

<style lang="scss"></style>
